import { render, staticRenderFns } from "./EditQuotasAction.vue?vue&type=template&id=3a948694&"
import script from "./EditQuotasAction.vue?vue&type=script&lang=js&"
export * from "./EditQuotasAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports